
import Vue from 'vue';

export default Vue.extend({
  name: 'Home',
  data() {
    return {}
  },

  computed: {
    auth(): boolean {
      return this.$store.getters.isAuthenticated
    },
    isAdmin(): boolean {
      return this.$store.getters.isAdmin;
    }
  },

  methods: {}
});
